import { Component } from '@angular/core';
@Component({
  selector: 'app-widget-rrss',
  standalone: false,
  templateUrl: './widget-rrss.component.html',
  styleUrl: './widget-rrss.component.css',
})
export class WidgetRrssComponent {
  visible=false;
  imgwhatsapp:any;
  imgcerrarchat:any;
  imgcall:any;

  constructor() {
    this.loadImage();
  }

  loadImage() {
    this.imgwhatsapp = '../../assets/icons/wapp.svg';
    this.imgcerrarchat = 'https://res.cloudinary.com/toyosa-sa/image/upload/v1721922048/production/toyota-bolivia/web/assets/icons/widget-cerrar-rojo.svg';
    this.imgcall = '../../assets/icons/call.svg';
  }

  open() {
    this.visible = true;
  }
  close() {
      this.visible = false;
  }
  onmousemove() {
    this.visible = true;
    setTimeout(() => {
      this.visible = false;
    }, 5000);
    
  }
}
